import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  CONTACTS_PATH,
  HOME_PAGE,
  LOGIN_PAGE,
  PROFILE_PAGE,
  REGISTRATION_PAGE,
  SALLES_PATH,
} from "../../routes/routes";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Drawer,
  IconButton,
  useTheme,
  Container,
  Typography,
  styled,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector, useDispatch } from "react-redux";
import { selectIsAutorization } from "../../redux/state/authReduser/authentification.selectors";

import ThemeToggle from "../../Themes/ThemeToggle";

import {
  appBarStyles,
  toolbarStyles,
  logoStyles,
  iconButtonStyles,
  drawerStyles,
  drawerBoxStyles,
  iconBtnStyles,
  logoImageStyles,
  menuButtonStyles,  // подключение стилей с эффектами свечения
} from "./Header.styled";

import logoImage from "../../assets/images/logo.jpg";
import { logOutThunk } from "../../redux/state/authReduser/services";

const Header = () => {
  const dispatch = useDispatch();
  const isAutentificate = useSelector(selectIsAutorization);
  const [open, setOpen] = useState(false);
  const theme = useTheme();

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const closeDrawer = () => {
    setOpen(false);
  };

  const handleLogOut = () => {
    dispatch(logOutThunk());
  };

  const LogoLink = styled(Link)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: theme.palette.text.primary,
    fontSize: '24px',
    fontWeight: 'bold',
    transition: 'color 0.3s ease, transform 0.3s ease',

    '& span': {
      fontSize: '18px',
      color: theme.palette.primary.main,
      marginLeft: '4px',
    },

    '&:hover': {
      color: theme.palette.primary.dark,
      transform: 'scale(1.1)',
    },

    '&:active': {
      transform: 'scale(1)', 
    },
  }));

  const menuItems = (
    <>
      <Button
        key={HOME_PAGE}
        component={NavLink}
        to={HOME_PAGE}
        sx={menuButtonStyles(theme)}  // Применение эффектов свечения
        onClick={closeDrawer}
      >
        Главная
      </Button>
      <Button
        key={CONTACTS_PATH}
        component={NavLink}
        to={CONTACTS_PATH}
        sx={menuButtonStyles(theme)}  // Применение эффектов свечения
        onClick={closeDrawer}
      >
        Контакты
      </Button>
      <Button
        key={SALLES_PATH}
        component={NavLink}
        to={SALLES_PATH}
        sx={menuButtonStyles(theme)}  // Применение эффектов свечения
        onClick={closeDrawer}
      >
        Акции
      </Button>

      {!isAutentificate && (
        <>
          <Button
            key={REGISTRATION_PAGE}
            component={NavLink}
            to={REGISTRATION_PAGE}
            sx={menuButtonStyles(theme)}  // Применение эффектов свечения
            onClick={closeDrawer}
          >
            Регистрация
          </Button>
          <Button
            key={LOGIN_PAGE}
            component={NavLink}
            to={LOGIN_PAGE}
            sx={menuButtonStyles(theme)}  // Применение эффектов свечения
            onClick={closeDrawer}
          >
            Вход
          </Button>
        </>
      )}

      {isAutentificate && (
        <>
          <Button
            key={PROFILE_PAGE}
            component={NavLink}
            to={PROFILE_PAGE}
            sx={menuButtonStyles(theme)}  // Применение эффектов свечения
            onClick={closeDrawer}
          >
            Профиль
          </Button>
          <Button
            key="logOut"
            sx={menuButtonStyles(theme)}  // Применение эффектов свечения
            onClick={handleLogOut}
          >
            Выйти
          </Button>
        </>
      )}
    </>
  );

  return (
    <AppBar position="sticky" sx={appBarStyles}>
      <Toolbar sx={toolbarStyles}>
        <Container maxWidth="xl" sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <LogoLink to="/home" sx={logoStyles}>
            <img src={logoImage} alt="logo" style={logoImageStyles} />
          </LogoLink>

          <Box sx={{ display: { xs: "block", sm: "none" } }}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer}
              sx={iconButtonStyles}
            >
              <MenuIcon />
            </IconButton>
          </Box>

          <Box sx={{ display: { xs: "none", sm: "flex" }, justifyContent: "center", flex: 1 }}>
            <ThemeToggle />
          </Box>

          <Box sx={{ display: { xs: "none", sm: "flex" }, gap: 2 }}>
            {menuItems}
          </Box>

          <Drawer
            anchor="right"
            open={open}
            onClose={toggleDrawer}
            sx={{
              ...drawerStyles,
              backgroundColor: theme.palette.mode === "light" ? "#fff" : "#121212",
              color: theme.palette.mode === "light" ? "#000" : "#fff",
            }}
          >
            <Box
              sx={{
                ...drawerBoxStyles,
                backgroundColor: theme.palette.mode === "light" ? "#fff" : "#121212",
                color: theme.palette.mode === "light" ? "#000" : "#fff",
              }}
            >
              <IconButton
                edge="start"
                color="inherit"
                aria-label="close"
                onClick={closeDrawer}
                sx={iconBtnStyles}
              >
                <CloseIcon />
              </IconButton>

              <Box sx={{ display: "flex", justifyContent: "center", paddingBottom: "20px" }}>
                <ThemeToggle />
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <Typography variant="h6" sx={{ textAlign: "center", paddingBottom: "10px" }}>
                  Навигация
                </Typography>
                {menuItems}
              </Box>
            </Box>
          </Drawer>
        </Container>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
